// Libs
import React, { useContext, useEffect, useState } from 'react';
import { Modal, Tooltip } from 'antd';
import { FormikProps } from 'formik';

// Own Libs
import * as ui from '@digital/ui';

//Api
import {
  createDemanda,
  pausarDemanda,
  updateDemanda,
  retomarDemanda,
  FinalizarEtapaDadosQuestionario,
  Demanda,
  cancelarOCDemanda,
} from '../../../../api/demanda';
import { IPerguntaRespostaSelecionadas, postCriarMinuta } from '@app/api/minuta/QuestionarioMinuta';

//Files
import DadosDemandaFields from './telaSteps/DadosDemandaFields';
import DadosQuantitativosStep from './telaSteps/DadosQuantitativosStep';
import DadosRequisitanteFields from './telaSteps/DadosRequisitanteFields';
import DefinicaoAdtivo from './telaSteps/DefinicaoAdtivo';
import DefinicaoProcessoFields from './telaSteps/DefinicaoProcessoFields';
import IdentificacaoAdtivo from './telaSteps/IdentificacaoAdtivo';
import UploadArquivosFields from './telaSteps/UploadArquivosFields';
import RequisicaoCompraObjetoJustificativa from './telaSteps/RequisicaoCompraObjetoJustificativa';
import RequisicaoCompraItemOiOmLotacao from './telaSteps/RequisicaoCompraItemOiOmLotacao';
import RequisicaoCompraValorEFornecedorDirecionado from './telaSteps/RequisicaoCompraValorEFornecedorDirecionado';
import RequisicaoCompraOcDdi from './telaSteps/RequisicaoCompraOcDdi';
import Validacao from './telaSteps/Validacao';
import StepDadosRequisicao from './telaSteps/StepDadosRequisicao';
import { MinutaDeContratoStep } from './telaSteps/MinutaDeContratoStep';
import ValidacaoControladoriaDemanda from './telaSteps/ValidacaoControladoriaDemanda';
import ModalReabrirRc from './ModalReabrirRc';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';
import { PerguntaRespostaComponent } from '@app/components/PerguntaRespostaComponent';
import V2StepPanel from '@app/components/Stepsv2/V2StepPanel';
import { IGroupItemStep, IItemStep } from '@app/components/Stepsv2/interfaces';
import ModalEliminarDemanda from './ModalEliminarDemanda';
import { ModalModificarDemanda } from './ModalModificarDemanda';

//Utils
import { getLoggedId } from '@app/helpers';
import QuestionarioContextProvider from '../../../../hooks/useQuestionario';
import {
  EStepQuestionarioDemanda,
  EStepQuestionarioDemandaAditivo,
  EStepQuestionarioDemandaFaturamentoDireto,
  EStepQuestionarioDemandaMinuta,
  EStepQuestionarioDemandaNovaContratacao,
  EStepQuestionarioDemandaReavaliacaoRC,
  EStepQuestionarioDemandaRequisicao,
  EStepQuestionarioDemandaRequisicaoModificacao,
  EStepQuestionarioDemandaValidacao,
} from '@app/enums/EStepQuestionarioDemanda';
import { EStatusDemanda } from '@app/enums/EStatusDemanda';
import { hasPermission, hasPermissionPerfil } from '@app/helpers/permissions';
import { EGuidPerfilAcesso } from '@app/enums/EGuidPerfilAcesso';
import { isObjEmpty, isObjNotEmpty } from '@app/helpers/objHelper';
import DefinicaoReavaliacao from './telaSteps/DefinicaoReavaliacao';
import { ModalInclusaoMultAnexo } from '@app/components';
import { ETipoReavaliacaoDemanda } from '@app/enums/ETipoReavaliacaoDemanda';
import { ModalModificarRC } from './ModalModificarRC';
import UploadArquivosFaturamentoDiretoFields from './telaSteps/UploadArquivosFaturamentoDiretoFields';
import DadosDemandaFaturamentoDiretoFields from './telaSteps/DadosDemandaFaturamentoDiretoFields';
import AprovacaoFaturamentoDireto from './telaSteps/AprovacaoFaturamentoDireto';
import ConcluidoFaturamentoDireto from './telaSteps/ConcluidoFaturamentoDireto';
import DadosDemandaAditivoFaturamentoDiretoFields from './telaSteps/DadosDemandaAditivoFaturamentoDiretoFields';

const demandaForm = () => {
  const { demandaData } = useContext(QuestionarioContextProvider);

  if (!demandaData) {
    return <></>;
  }

  return (
    <>
      <ui.Row>
        <ui.FormInput
          id="mrn-input-demanda-identificadorTexto"
          label="Identificação"
          name="identificadorTexto"
          span={4}
          disabled
        />
        <ui.FormInput id="mrn-input-demanda-status" label="Status" name="status" disabled span={4} />
        <ui.FormInput id="mrn-input-demanda-createdBy" label="Demandante" name="createdBy" span={4} disabled />
      </ui.Row>
      {demandaData && demandaData.justificativaDevolucao && demandaData.statusCodigo === 1 ? (
        <ui.Row>
          <ui.FormTextArea
            id="mrn-textarea-demanda-justificativaDevolucao"
            label="Justificativa da Devolução"
            name="justificativaDevolucao"
            disabled
            rows={4}
          />
        </ui.Row>
      ) : (
        <></>
      )}
    </>
  );
};

const { confirm } = Modal;

function EditQuestionarioContratacao() {
  const { history } = ui.useRouter();
  const [loggedId] = useState(getLoggedId());
  const {
    statusCodigo,
    setStatusCodigo,
    setStatusPrazo,
    setStatusPrazoExtenso,
    setTipoDemanda,
    setDemandaData,
    setDescOi,
    demandaData,
    capex,
    opex,
    contaResultado,
    setCapex,
    setOpex,
    setContaResultado,
    setExibirModalFinalizarEtapaRequisicao,
    update,
    setUpdate,
    setIsEmergencial,
    setIsVisitaTecnica,
    setIsFornecedorDirecionado,
    codCentroDeCusto,
    setCodCentroDeCusto,
    centroDeCusto,
    setCentroDeCusto,
    codLotacaoDestino,
    setCodLotacaoDestino,
    lotacaoDestino,
    setLotacaoDestino,
    codOrdemInvestimento,
    setCodOrdemInvestimento,
    ordemInvestimento,
    setOrdemInvestimento,
    ordemManutencao,
    setOrdemManutencao,
    itemServico,
    setItemServico,
    valorAditivo,
    setValorAditivo,
    isPrazo,
    setIsPrazo,
    isClausula,
    setIsClausula,
    isValorSemAcrescimoEscopo,
    setIsValorSemAcrescimoEscopo,
    isValorComAcrescimoEscopo,
    setIsValorComAcrescimoEscopo,
    setId,
    setExibirModalFinalizarEtapaDados,
    setDiretoriaId,
    diretoriaId,
    setAreaId,
    areaId,
    setDepartamentoId,
    departamentoId,
    minAprovacaoGpc,
    exibirModalEnviarPreSuprimentos,
    setExibirModalEnviarPreSuprimentos,
    exibirModalEnviarValidacaoCapex,
    setExibirModalEnviarValidacaoCapex,
    numeroContrato,
    setNumeroContrato,
    numeroPedido,
    setNumeroPedido,
    numeroPcs,
    setNumeroPcs,
    prazoAtualPcs,
    setPrazoAtualPcs,
    isRemanejamentoVerbasEntreLinhas,
    setIsRemanejamentoVerbasEntreLinhas,
    isAcrescimoEscopoRemanejamentoVerba,
    setIsAcrescimoEscopoRemanejamentoVerba,
    requisicaoAbertaPeloDepPlanejamentoControle,
    setRequisicaoAbertaPeloDepPlanejamentoControle,
    pacote,
    setPacote,
    projeto,
    setProjeto,
    id,
    tipoContrato,
    setTipoContrato,
    expectativaDePrazoConfirmacao,
    setHaveraMaoDeObraEmPTRConfirmacao,
    haveraMaoDeObraEmPTRConfirmacao,
    haveraSlaConfirmacao,
    haveraDespesasReembolsaveisConfirmacao,
    novoPrazoConfirmacao,
    isVisitaTecnicaConfirmacao,
    gestorTecnicoId,
    setGestorTecnicoId,
    exibirModalEnviarValidacaoOpex,
    setExibirModalEnviarValidacaoOpex,
    exibirModalEnviarValidacaoContaResultado,
    setExibirModalEnviarValidacaoContaResultado,
    isAdmContrato,
    isGPC,
    caracteristicaContratacao,
    setValorPedido,
    valorPedido,
    vigencia,
    setVigencia,
    setValorTotalContrato,
    valorTotalContrato,
    condicaoPagamento,
    setCondicaoPagamento,
    justificativaContratacao,
    setJustificativaContratacao,
    objetoContratado,
    setObjetoContratado,
    relacionamentoEntidadePublica,
    setRelacionamentoEntidadePublica,
    tipoFaturamento,
    setTipoFaturamento,
    setExibirModalFinalizarEtapaFaturamentoDireto,
    validarAnexosObrigatorios,
    selectedItemCodigoContrato,
    setSelectedItemCodigoContrato,
    setSelectedOrdemCompra,
    setSelectedOrdemInvestimento,
    selectedOrdemInvestimento,
    selectedOrdemCompra,
    identificadorPQ,
    numeroContratoPcs
  } = useContext(QuestionarioContextProvider);

  const [numberIdStep, setNumberIdStep] = useState<number>(EStepQuestionarioDemanda.DadosdoRequisitante);
  const [stepOrdinal, setStepOrdinal] = useState<number>(0);
  const [legend, setLegend] = useState<string | undefined>();
  const [stepsGroup, setStepsGroup] = useState<IGroupItemStep[]>([]);

  const [respostasPerguntaQuestionarioMinuta, setRespostasPerguntaQuestionarioMinuta] = useState<
    IPerguntaRespostaSelecionadas[]
  >([]);

  const onUpdate = () => {
    setUpdate(!update);
  };

  useEffect(() => {
    onUpdate();
  }, []);

  /**
   * DEFINIÇÃO DOS PASSOS
   */
  useEffect(() => {
    let tempSteps: IGroupItemStep[] = [];

    const ehIdentificadorMenor = demandaData && demandaData.identificador <= 3030;

    let formulario = {
      title: 'Formulário',
      order: 1,
      steps: [] as IItemStep[],
    } as IGroupItemStep;

    let validacao = {
      title: 'Validação',
      order: 2,
      steps: [] as IItemStep[],
    } as IGroupItemStep;

    let minutaContratual = {
      title: 'Minuta Contratual',
      order: 3,
      steps: [] as IItemStep[],
    } as IGroupItemStep;

    let requisicaoCompra = {
      title: 'Requisição de Compra',
      order: 4,
      steps: [] as IItemStep[],
    } as IGroupItemStep;

    formulario.steps = [
      {
        stepNumber: EStepQuestionarioDemanda.DadosdoRequisitante,
        title: 'Dados do Requisitante',
        description: 'Diretoria, área e departamento',
        content: (
          <DadosRequisitanteFields
            disabled={
              demandaData &&
              [EStatusDemanda.AguardandoAnaliseSuprimentos, EStatusDemanda.Concluido].includes(
                demandaData.statusCodigo || 0,
              )
            }
          />
        ),
        visible: true,
      },
      {
        stepNumber: EStepQuestionarioDemanda.DefinicaodoProcesso,
        title: 'Definição do Processo',
        description: 'Nova contratação ou aditivo',
        content: (
          <DefinicaoProcessoFields
            disabled={
              demandaData &&
              [EStatusDemanda.AguardandoAnaliseSuprimentos, EStatusDemanda.Concluido].includes(
                demandaData.statusCodigo || 0,
              )
            }
          />
        ),
        visible: true,
      },
    ];

    const mostrarPassosFaturamentoDireto = demandaData && demandaData.tipo === ETipoDemanda.FaturamentoDireto || demandaData && demandaData.tipo === ETipoDemanda.AditivoFaturamentoDireto;

    if (mostrarPassosFaturamentoDireto) {
      formulario.steps.push({
        stepNumber: EStepQuestionarioDemandaFaturamentoDireto.DadosdaDemanda,
        title: 'Dados da Demanda',
        description: 'Objeto, tipo de Serviço, valor etc.',
        content:
          demandaData && demandaData.tipo === ETipoDemanda.AditivoFaturamentoDireto ? (
            <DadosDemandaAditivoFaturamentoDiretoFields />
          ) : (
            <DadosDemandaFaturamentoDiretoFields />
          ),
        visible: mostrarPassosFaturamentoDireto,
      });
      if (demandaData && demandaData.tipo === ETipoDemanda.AditivoFaturamentoDireto)
      {
        formulario.steps.push({
          stepNumber: EStepQuestionarioDemandaFaturamentoDireto.DefinicaoAditivo,
          title: 'Definição Aditivo',
          description: 'Prazo, valor, Escopo, Cláusula',
          content: <DefinicaoAdtivo />,
          visible: demandaData && demandaData.tipo === ETipoDemanda.AditivoFaturamentoDireto,
        });
      }

      formulario.steps.push({
        stepNumber: EStepQuestionarioDemandaFaturamentoDireto.Arquivos,
        title: 'Arquivos',
        description: 'Upload de arquivos',
        content: <UploadArquivosFaturamentoDiretoFields />,
        visible: true,
      });

      formulario.steps.push({
        stepNumber: EStepQuestionarioDemandaFaturamentoDireto.Aprovacao,
        title: 'Aprovação',
        description: '',
        content: <AprovacaoFaturamentoDireto />,
        visible: true,
      });

    }

    const mostrarPassosNovaContratacao =
      !demandaData ||
      (demandaData && !demandaData.tipo) ||
      (demandaData && demandaData.tipo === ETipoDemanda.NovaContratacao);

    formulario.steps.push({
      stepNumber: EStepQuestionarioDemandaNovaContratacao.DadosdaDemanda,
      title: 'Dados da Demanda',
      description: 'Objeto, tipo de Serviço, valor etc.',
      content: <DadosDemandaFields />,
      visible: mostrarPassosNovaContratacao,
    });

    formulario.steps.push({
      stepNumber: EStepQuestionarioDemandaNovaContratacao.DadosQuantitativos,
      title: 'Dados Quantitativos/ Prev. Orçamentária',
      description: 'Valor, prazo e orçamento',
      content: <DadosQuantitativosStep />,
      visible: mostrarPassosNovaContratacao,
    });

    formulario.steps.push({
      stepNumber: EStepQuestionarioDemandaAditivo.IdentificacaodoContrato,
      title: 'Identificação do Contrato',
      description: tipoContrato === 'pcs' ? 'PCS – Pedido de Compra de Serviço' : 'Contrato',
      content: <IdentificacaoAdtivo />,
      visible: demandaData && demandaData.tipo === ETipoDemanda.Aditivo,
    });

    formulario.steps.push({
      stepNumber: EStepQuestionarioDemandaAditivo.DefinicaoAditivo,
      title: 'Definição Aditivo',
      description: 'Prazo, valor, Escopo, Cláusula',
      content: <DefinicaoAdtivo />,
      visible: demandaData && demandaData.tipo === ETipoDemanda.Aditivo,
    });

    formulario.steps.push({
      stepNumber: EStepQuestionarioDemanda.ControladoriaOuControleFinanceiro,
      title: 'Validação Econômica',
      description: 'Controle Financeiro / Controladoria',
      content: <ValidacaoControladoriaDemanda />,
      visible:
        demandaData &&
        demandaData.tipo !== ETipoDemanda.AcordodeFornecimento &&
        demandaData.tipo !== ETipoDemanda.FaturamentoDireto &&
        demandaData.tipo !== ETipoDemanda.AditivoFaturamentoDireto,
    });

    if (
      !mostrarPassosFaturamentoDireto &&
      (mostrarPassosNovaContratacao ||
        (demandaData && (demandaData.tipo !== ETipoDemanda.AcordodeFornecimento || !demandaData.tipo)))
    ) {
      formulario.steps.push({
        stepNumber: EStepQuestionarioDemanda.Arquivos,
        title: 'Arquivos',
        description: 'Upload de arquivos',
        content: <UploadArquivosFields />,
        visible: true,
      });

      formulario.steps.push({
        stepNumber: EStepQuestionarioDemanda.DadosRequisicao,
        title: 'Dados da Requisição',
        description: 'Emergência e Direcionamento',
        content: <StepDadosRequisicao />,
        visible: !isAdmContrato,
      });
      formulario.steps.push({
        stepNumber: EStepQuestionarioDemandaRequisicao.AguardandoAprovacaoRC, //11
        title: 'Aguardando Aprovação RC',
        description: 'Geração OC',
        content: <RequisicaoCompraOcDdi />,
        visible: true,
      });

      tempSteps.push(formulario);

      validacao.steps = [
        {
          stepNumber: EStepQuestionarioDemandaValidacao.PreContratacao,
          title: 'Pré-Contratação',
          description: ' ',
          content: <Validacao />,
          visible: true,
        },
      ];
      tempSteps.push(validacao);

      const visualizarTimelineMinuta =
        [
          EStatusDemanda.AguardandoQuestionarioMinuta,
          EStatusDemanda.AguardandoConfirmacaoQuestionarioMinuta,
          EStatusDemanda.AguardandoGeracaoMinuta,
        ].includes(statusCodigo || 0) ||
        (demandaData && (demandaData.novoValorFinal || 0) >= (minAprovacaoGpc || 0));

      if (mostrarPassosNovaContratacao || visualizarTimelineMinuta) {
        let stepInit = EStepQuestionarioDemandaMinuta.MinutadeContrato;
        minutaContratual.steps = [];

        minutaContratual.steps.push({
          stepNumber: stepInit,
          title: 'Minuta de Contrato',
          description: ' ',
          content: <MinutaDeContratoStep />,
          visible: mostrarPassosNovaContratacao || visualizarTimelineMinuta,
          stepFrontendControl: statusCodigo === EStatusDemanda.AguardandoConfirmacaoQuestionarioMinuta,
        });

        if (
          demandaData &&
          demandaData.perguntasQuestionarioMinuta &&
          statusCodigo === EStatusDemanda.AguardandoConfirmacaoQuestionarioMinuta
        ) {
          demandaData.perguntasQuestionarioMinuta.forEach((pergunta, index) => {
            minutaContratual.steps.push({
              hash: pergunta.id,
              stepNumber: stepInit,
              title: pergunta.pergunta,
              content: (
                <PerguntaRespostaComponent
                  dadosDaPergunta={pergunta}
                  onGetRespostasQuestionario={setRespostasPerguntaQuestionarioMinuta}
                  perguntaReadonly={true}
                  footer={true}
                />
              ),
              visible:
                demandaData &&
                demandaData.perguntasQuestionarioMinuta &&
                statusCodigo === EStatusDemanda.AguardandoConfirmacaoQuestionarioMinuta,
              stepFrontendControl:
                (demandaData.perguntasQuestionarioMinuta && demandaData.perguntasQuestionarioMinuta.length - 1) !==
                index,
            });
          });
        }

        tempSteps.push(minutaContratual);
      }

      const emModificacao = demandaData && demandaData.isModificando;
      requisicaoCompra.steps = [
        {
          stepNumber: EStepQuestionarioDemandaRequisicao.ObjetoeJustificativa, //8
          title: 'Objeto e Justificativa',
          description: ' ',
          content: (
            <RequisicaoCompraObjetoJustificativa
              forceDisabled={emModificacao ? false : ehIdentificadorMenor ? false : true}
            />
          ),
          visible: true,
        },
        {
          stepNumber: EStepQuestionarioDemandaRequisicao.ItemdeServicoeAlocacaodeCusto, //9
          title: 'Item de Serviço e Alocação de Custo',
          description: ' ',
          content: (
            <RequisicaoCompraItemOiOmLotacao
              disabled={
                demandaData &&
                [EStatusDemanda.AguardandoAnaliseSuprimentos, EStatusDemanda.Concluido].includes(
                  demandaData.statusCodigo || 0,
                ) &&
                (ehIdentificadorMenor ? false : true)
              }
              // forceDisabled={ehIdentificadorMenor ? false : true}
            />
          ),
          visible: true,
        },
        {
          stepNumber: EStepQuestionarioDemandaRequisicao.ValorDirecionamentoeEmergencial, //10
          title: 'Valor, Direcionamento e Emergencial',
          description: ' ',
          content: (
            <RequisicaoCompraValorEFornecedorDirecionado
              disabled={
                demandaData &&
                [EStatusDemanda.AguardandoAnaliseSuprimentos, EStatusDemanda.Concluido].includes(
                  demandaData.statusCodigo || 0,
                )
              }
              forceDisabled={ehIdentificadorMenor ? false : true}
            />
          ),
          visible: true,
        },
        {
          stepNumber: EStepQuestionarioDemandaRequisicao.AguardandoAprovacaoRC, //11
          title: 'Aguardando Aprovação RC',
          description: 'Geração OC',
          content: <RequisicaoCompraOcDdi />,
          visible: true,
        },
        {
          stepNumber: EStepQuestionarioDemandaRequisicao.AguardandoSuprimentos, //12
          title: 'Aguardando Suprimentos',
          description: 'Efetivação Demanda',
          content: <RequisicaoCompraOcDdi />,
          visible: true,
          status: emModificacao ? 'wait' : undefined,
        },
      ];
      tempSteps.push(requisicaoCompra);

      if (emModificacao) {
        const disableFields = statusCodigo != EStatusDemanda.AguardandoRCDemandanteModificacao;
        let modificacaoRequisicaoCompra = {
          title: 'Modificação da Requisição de Compra',
          order: 5,
          steps: [] as IItemStep[],
        } as IGroupItemStep;

        modificacaoRequisicaoCompra.steps = [
          {
            stepNumber: EStepQuestionarioDemandaRequisicaoModificacao.ObjetoeJustificativa,
            title: 'Objeto e Justificativa',
            description: ' ',
            content: <RequisicaoCompraObjetoJustificativa forceDisabled={disableFields} />,
            visible: true,
          },
          {
            stepNumber: EStepQuestionarioDemandaRequisicaoModificacao.ItemdeServicoeAlocacaodeCusto,
            title: 'Item de Serviço e Alocação de Custo',
            description: ' ',
            content: <RequisicaoCompraItemOiOmLotacao disabled={disableFields} isModification={true} />,
            visible: true,
          },
          {
            stepNumber: EStepQuestionarioDemandaRequisicaoModificacao.ValorDirecionamentoeEmergencial,
            title: 'Valor, Direcionamento e Emergencial',
            description: ' ',
            content: <RequisicaoCompraValorEFornecedorDirecionado forceDisabled={disableFields} />,
            visible: true,
          },
          {
            stepNumber: EStepQuestionarioDemandaRequisicaoModificacao.RevalidacaoEconomica,
            title: 'Revalidação Econômica',
            description: 'Controle Financeiro / Controladoria',
            content: <ValidacaoControladoriaDemanda />,
            visible: demandaData.necessitaRevalidacaoEconomica,
          },
          {
            stepNumber: EStepQuestionarioDemandaRequisicaoModificacao.AguardandoAprovacaoRC,
            title: 'Aguardando Aprovação RC',
            description: 'Geração OC',
            content: <RequisicaoCompraOcDdi />,
            visible: true,
          },
          {
            stepNumber: EStepQuestionarioDemandaRequisicaoModificacao.AguardandoSuprimentos,
            title: 'Aguardando Suprimentos',
            description: 'Efetivação Demanda',
            content: <RequisicaoCompraOcDdi />,
            visible: true,
          },
        ];
        tempSteps.push(modificacaoRequisicaoCompra);
      }
    } else {
      if (!mostrarPassosFaturamentoDireto) {
        formulario.steps.push({
          stepNumber: 3,
          title: 'Aguardando Aprovação RC',
          description: 'Geração OC',
          content: <RequisicaoCompraOcDdi />,
          visible: true,
        });
      }

      tempSteps.push(formulario);
    }

    const exibirStepsReavaliacaoRequisicaoCompra =
      statusCodigo === EStatusDemanda.AguardandoRCReabertura || (!!demandaData && !!demandaData.tipoReavaliacao);
    if (exibirStepsReavaliacaoRequisicaoCompra) {
      const reavaliacaoRequisicaoCompra = {
        title: 'Reavaliação da Requisição de Compra',
        order: 6,
        steps: [] as IItemStep[],
      } as IGroupItemStep;

      reavaliacaoRequisicaoCompra.steps = [
        {
          stepNumber: EStepQuestionarioDemandaReavaliacaoRC.DefinicaoReavaliacao,
          title: 'Definição da Reavaliação',
          description: ' ',
          content: <DefinicaoReavaliacao disabled={statusCodigo !== EStatusDemanda.AguardandoRCReabertura} />,
          visible: true,
        },
        {
          stepNumber: EStepQuestionarioDemandaReavaliacaoRC.RevalidacaoEconomica,
          title: 'Revalidação Econômica',
          description: 'Controle Financeiro / Controladoria',
          content: <ValidacaoControladoriaDemanda />,
          visible: demandaData && demandaData.necessitaRevalidacaoEconomica,
        },
        {
          stepNumber: EStepQuestionarioDemandaReavaliacaoRC.ObjetoeJustificativa,
          title: 'Objeto e Justificativa',
          description: ' ',
          content: (
            <RequisicaoCompraObjetoJustificativa
              forceDisabled={statusCodigo !== EStatusDemanda.AguardandoRCDemandanteReavaliacao}
            />
          ),
          visible: demandaData && demandaData.tipoReavaliacao === ETipoReavaliacaoDemanda.AbrirNovaRC,
        },
        {
          stepNumber: EStepQuestionarioDemandaReavaliacaoRC.ItemdeServicoeAlocacaodeCusto,
          title: 'Item de Serviço e Alocação de Custo',
          description: ' ',
          content: (
            <RequisicaoCompraItemOiOmLotacao
              disabled={statusCodigo !== EStatusDemanda.AguardandoRCDemandanteReavaliacao}
            />
          ),
          visible: demandaData && demandaData.tipoReavaliacao === ETipoReavaliacaoDemanda.AbrirNovaRC,
        },
        {
          stepNumber: EStepQuestionarioDemandaReavaliacaoRC.ValorDirecionamentoeEmergencial,
          title: 'Valor, Direcionamento e Emergencial',
          description: ' ',
          content: (
            <RequisicaoCompraValorEFornecedorDirecionado
              forceDisabled={statusCodigo !== EStatusDemanda.AguardandoRCDemandanteReavaliacao}
            />
          ),
          visible: demandaData && demandaData.tipoReavaliacao === ETipoReavaliacaoDemanda.AbrirNovaRC,
        },
        {
          stepNumber: EStepQuestionarioDemandaReavaliacaoRC.AguardandoAprovacaoRC,
          title: 'Aguardando Aprovação RC',
          description: 'Geração OC',
          content: <RequisicaoCompraOcDdi />,
          visible: demandaData && demandaData.tipoReavaliacao === ETipoReavaliacaoDemanda.AbrirNovaRC,
        },
        {
          stepNumber: EStepQuestionarioDemandaReavaliacaoRC.AguardandoSuprimentos,
          title: 'Aguardando Suprimentos',
          description: ' ',
          content: (
            <>
              <div style={{ textAlign: 'center' }}>
                <h3 style={{ color: 'rgb(105,105,105)' }}>Sua demanda foi direcionada para Suprimentos.</h3>
              </div>
            </>
          ),
          visible: true,
        },
      ];

      tempSteps.push(reavaliacaoRequisicaoCompra);
    }

    setStepsGroup(tempSteps);
  }, [demandaData, tipoContrato, statusCodigo, minAprovacaoGpc]);

  useEffect(() => {
    if (demandaData) {
      if (demandaData.statusCodigo) {
        setStatusCodigo(demandaData.statusCodigo);
        setStatusPrazo(demandaData.statusPrazo);
        setStatusPrazoExtenso(demandaData.statusPrazoExtenso);
      }
      if (demandaData.tipo !== ETipoDemanda.AditivoFaturamentoDireto) {
             setNumeroContrato(demandaData.numeroContrato || '');
      }
      setNumeroPedido(demandaData.numeroPedido || '');
      setNumeroPcs(demandaData.numeroPedido ? demandaData.numeroPedido.toString() : '');
      setTipoDemanda(demandaData.tipo);
      setTipoContrato(demandaData.tipoContrato);
      // setActiveStep(demandaData.step);
      setDescOi(demandaData.descOrdemInvestimento);
      setIsEmergencial(demandaData.isEmergencial || false);
      setIsVisitaTecnica(demandaData.isVisitaTecnica);
      setIsFornecedorDirecionado(demandaData.isFornecedorDirecionado || false);
      setCodCentroDeCusto(demandaData.codCentroDeCusto || '');
      setCentroDeCusto(demandaData.centroDeCusto || '');
      setCodLotacaoDestino(demandaData.codLotacaoDestino || '');
      setLotacaoDestino(demandaData.lotacaoDestino || '');
      setCodOrdemInvestimento(demandaData.codOrdemInvestimento || '');
      setOrdemInvestimento(demandaData.ordemInvestimento || '');
      setOrdemManutencao(demandaData.ordemManutencao || '');
      setItemServico(demandaData.codItemServico || '');
      setValorAditivo(demandaData.valorAditivo || 0);
      setIsPrazo(demandaData.isPrazo);
      setIsClausula(demandaData.isClausula);
      setIsValorSemAcrescimoEscopo(demandaData.isValorSemAcrescimoEscopo);
      setIsValorComAcrescimoEscopo(demandaData.isValorComAcrescimoEscopo);
      setIsRemanejamentoVerbasEntreLinhas(demandaData.isRemanejamentoVerbasEntreLinhas);
      setIsAcrescimoEscopoRemanejamentoVerba(demandaData.isAcrescimoEscopoRemanejamentoVerba);
      setDiretoriaId(demandaData.diretoriaId);
      setAreaId(demandaData.areaId);
      setDepartamentoId(demandaData.departamentoId);
      setCapex(demandaData.capex);
      setOpex(demandaData.opex);
      setContaResultado(demandaData.contaResultado);
      setRequisicaoAbertaPeloDepPlanejamentoControle(demandaData.requisicaoAbertaPeloDepPlanejamentoControle);
      setPacote(demandaData.pacote || '');
      setProjeto(demandaData.projeto || '');
      setGestorTecnicoId(demandaData.gestorTecnicoId);

      setRelacionamentoEntidadePublica(demandaData.relacionamentoEntidadePublica);
      setHaveraMaoDeObraEmPTRConfirmacao(demandaData.haveraMaoDeObraEmPTR);

      setValorPedido(demandaData.valorPedido);
      setVigencia(demandaData.vigencia);
      setValorTotalContrato(demandaData.valorTotalContrato);
      setCondicaoPagamento(demandaData.condicaoPagamento);
      setTipoFaturamento(demandaData.tipoFaturamento);
      if (demandaData.prazoAtual) setPrazoAtualPcs(demandaData.prazoAtual);
      setJustificativaContratacao(demandaData.justificativa);
      setObjetoContratado(demandaData.objeto);
      setSelectedItemCodigoContrato(demandaData.itemCodigoContrato || '');

      setSelectedOrdemCompra(demandaData.ordemCompraGuardaChuva || '');
      setSelectedOrdemInvestimento(demandaData.ordemInvestimentoGuardaChuva || '');
    }
  }, [demandaData, setDemandaData, setDescOi, setStatusCodigo, setTipoDemanda]);

  /**
   * DEFINIÇÃO DA LEGENDA
   */
  useEffect(() => {
    switch (statusCodigo) {
      case undefined:
      case 0:
      case EStatusDemanda.AguardandoPreenchimentoDemandante:
        if (
          [
            EStepQuestionarioDemandaValidacao.PreContratacao,
            EStepQuestionarioDemanda.ControladoriaOuControleFinanceiro,
          ].includes(numberIdStep || 0)
        ) {
          setLegend(undefined);
        } else {
          setLegend('Preenchimento da Demanda');
        }
        break;
      case EStatusDemanda.AguardandoAnalisePreSuprimentos:
        setLegend('Aguardando Análise');
        break;
      case EStatusDemanda.AguardandoRCDemandante:
      case EStatusDemanda.AguardandoRCDemandanteReavaliacao:
        setLegend('Geração da Requisição');
        break;
      case EStatusDemanda.AguardandoGeracaoOCnoTotvs:
      case EStatusDemanda.AguardandoGeracaoOCnoTotvsModificacao:
      case EStatusDemanda.AguardandoGeracaoOCnoTotvsReavaliacao:
        if (
          numberIdStep == EStepQuestionarioDemandaRequisicao.AguardandoAprovacaoRC ||
          numberIdStep == EStepQuestionarioDemandaReavaliacaoRC.AguardandoAprovacaoRC
        ) {
          setLegend('Aguardando Ordem de Compra');
        }

        //#region Modificação
        if (
          [
            EStepQuestionarioDemandaRequisicaoModificacao.ObjetoeJustificativa,
            EStepQuestionarioDemandaRequisicaoModificacao.ItemdeServicoeAlocacaodeCusto,
            EStepQuestionarioDemandaRequisicaoModificacao.ValorDirecionamentoeEmergencial,
            EStepQuestionarioDemandaRequisicaoModificacao.AguardandoAprovacaoRC,
          ].includes(numberIdStep)
        ) {
          setLegend('Aguardando Ordem de Compra');
        }

        if (numberIdStep == EStepQuestionarioDemandaRequisicao.AguardandoSuprimentos) {
          setLegend('Aguardando Suprimentos');
        }

        if (numberIdStep == EStepQuestionarioDemandaRequisicaoModificacao.RevalidacaoEconomica) {
          setLegend(undefined);
        }
        //#endregion

        break;
      case EStatusDemanda.AguardandoAnaliseSuprimentos:
        setLegend('Aguardando Suprimentos');
        break;
      // case 6:
      //   setLegend('On Hold - Demandante');
      //   break;
      case EStatusDemanda.AguardandoAnaliseControleFinanceiro:
      case EStatusDemanda.AguardandoAnaliseControleFinanceiroModificacao:
      case EStatusDemanda.AguardandoAnaliseControleFinanceiroReavaliacao:
        setLegend('Aguardando Validação CAPEX/Conta Resultado');
        break;
      case EStatusDemanda.AguardandoQuestionarioMinuta:
        setLegend('Aguardando Questionário da Minuta');
      case EStatusDemanda.AguardandoConfirmacaoQuestionarioMinuta:
        setLegend('Aguardando Confirmação do Questionário');
        break;
      case EStatusDemanda.AguardandoGeracaoMinuta:
        setLegend('Aguardando Geração da Minuta');
        break;
      case EStatusDemanda.AguardandoGestorTecnico:
        setLegend('Aguardando Validação');
        break;
      case EStatusDemanda.AguardandoAnaliseControladoria:
      case EStatusDemanda.AguardandoAnaliseControladoriaModificacao:
      case EStatusDemanda.AguardandoAnaliseControladoriaReavaliacao:
        setLegend('Aguardando Análise Controladoria');
        break;
      case EStatusDemanda.AguardandoRCReabertura:
        setLegend(
          'O processo de contratação está paralisado até a aprovação da nova RC, e consequente emissão de nova OC. O prazo desta paralisação será acrescido ao prazo total do processo.',
        );
        break;
      case EStatusDemanda.AguardandoContratacaoSuprimentosReavaliacao:
        setLegend('Aguardando Suprimentos');
        break;
      default:
        setLegend('');
        break;
    }
  }, [demandaData, statusCodigo, numberIdStep]);

  const handlePausar = () => {
    if (demandaData) {
      pausarDemanda(demandaData.id).then(() => {
        onUpdate();
      });
    }
  };

  const handleRetomar = () => {
    if (demandaData) {
      retomarDemanda(demandaData.id).then(() => {
        onUpdate();
      });
    }
  };

  const verificarRespostasFaltantes = (): boolean => {
    let perguntaByStep: IItemStep = {} as IItemStep;
    var stepMinuta = stepsGroup.find(f => f.title === 'Minuta Contratual');

    if (stepMinuta) {
      perguntaByStep = stepMinuta.steps.find(f => f.order === stepOrdinal) || ({} as IItemStep);
      if (isObjNotEmpty(perguntaByStep)) {
        var pergunta: any = respostasPerguntaQuestionarioMinuta.find(f => f.id === perguntaByStep.hash);

        if (
          pergunta &&
          isObjNotEmpty(pergunta) &&
          (isObjEmpty(pergunta.isDeAcordo) || (pergunta.isDeAcordo === '2' && isObjEmpty(pergunta.comentario)))
        ) {
          return true;
        }
      }
    }

    return false;
  };

  const onEnviarDadosDasPerguntasMinutaQuestionario = () => {
    confirm({
      title: 'Confirmar Questionário Minuta?',
      content: 'Confirmar envio do questionário da minuta?',
      okText: 'Sim',
      cancelText: 'Não',
      onOk() {
        if (verificarRespostasFaltantes()) {
          ui.notification.error('Responda todas as perguntas antes de enviar');
          return;
        }

        if (!demandaData) {
          return;
        }

        var obj = {
          demandaId: demandaData.id,
          perguntas: respostasPerguntaQuestionarioMinuta,
        } as any;

        postCriarMinuta(obj).then(() => {
          onUpdate();
        });
      },
      onCancel() {},
    });
  };

  /**
   * IN0726-5080: espelha as guardas do switch de `onUpdateDemanda`. Responde se aquele
   * step, no status atual da demanda, tem de fato uma transição de saída.
   *
   * Sem isso o PRÓXIMO aparece e não faz nada, e o "Voltar" consegue gravar na demanda
   * um step de fase já concluída (ex.: Dados da Requisição com a RC já aberta), do qual
   * nem o frontend nem o backend sabem avançar — travando a demanda em definitivo.
   *
   * Faturamento Direto e Acordo de Fornecimento reaproveitam os mesmos números de step
   * com outro significado, por isso ficam fora desta validação.
   */
  const stepAvancaNoStatus = (step: number, status: number): boolean => {
    const tipo = demandaData && demandaData.tipo;

    if (
      tipo === ETipoDemanda.FaturamentoDireto ||
      tipo === ETipoDemanda.AditivoFaturamentoDireto ||
      tipo === ETipoDemanda.AcordodeFornecimento
    ) {
      return true;
    }

    switch (step) {
      // Steps da fase de preenchimento: só avançam com a demanda ainda em preenchimento.
      case EStepQuestionarioDemandaNovaContratacao.DadosQuantitativos: // = Aditivo.DefinicaoAditivo
      case EStepQuestionarioDemanda.Arquivos:
      case EStepQuestionarioDemanda.DadosRequisicao:
      case EStepQuestionarioDemandaValidacao.PreContratacao:
        return status === EStatusDemanda.AguardandoPreenchimentoDemandante;

      case EStepQuestionarioDemandaMinuta.MinutadeContrato:
        return status === EStatusDemanda.AguardandoConfirmacaoQuestionarioMinuta;

      default:
        return true;
    }
  };

  const onUpdateDemanda = async (values: Demanda): Promise<boolean> => {
    if (demandaData && !stepAvancaNoStatus(numberIdStep, statusCodigo || 0)) {
      // IN0726-5080: step sem transição de saída no status atual — nada a submeter.
      return false;
    }

    if (demandaData) {
      if (demandaData.tipo === ETipoDemanda.FaturamentoDireto || demandaData.tipo === ETipoDemanda.AditivoFaturamentoDireto) {
        if (numberIdStep == EStepQuestionarioDemandaFaturamentoDireto.Arquivos) {
          if (!validarAnexosObrigatorios()) {
            return false;
          }
        }
      }
    }

    values.ordemInvestimento = ordemInvestimento;
    values.codOrdemInvestimento = codOrdemInvestimento || '';
    values.centroDeCusto = centroDeCusto;
    values.codCentroDeCusto = codCentroDeCusto;
    values.codLotacaoDestino = codLotacaoDestino;
    values.lotacaoDestino = lotacaoDestino;
    values.ordemManutencao = ordemManutencao || '';
    values.codItemServico = itemServico || '';
    values.numeroContrato = numeroContrato || '';
    values.numeroPedido = demandaData && demandaData.tipo === ETipoDemanda.AditivoFaturamentoDireto ? numeroPcs || '' : numeroPedido || '';
    if (demandaData && demandaData.tipo === ETipoDemanda.AditivoFaturamentoDireto) {
      values.tipoContrato = tipoContrato;
      values.numeroContratoPcs = numeroContratoPcs || '';      
    }

    values.valorAditivo = valorAditivo;
    values.isPrazo = isPrazo;
    values.isClausula = isClausula;
    values.isValorSemAcrescimoEscopo = isValorSemAcrescimoEscopo;
    values.isValorComAcrescimoEscopo = isValorComAcrescimoEscopo;
    values.diretoriaId = diretoriaId || '';
    values.departamentoId = departamentoId || '';
    values.areaId = areaId || '';
    values.isRemanejamentoVerbasEntreLinhas = isRemanejamentoVerbasEntreLinhas;
    values.isAcrescimoEscopoRemanejamentoVerba = isAcrescimoEscopoRemanejamentoVerba;
    values.capex = capex || false;
    values.opex = opex || false;
    values.contaResultado = contaResultado;
    values.requisicaoAbertaPeloDepPlanejamentoControle = requisicaoAbertaPeloDepPlanejamentoControle;
    values.projeto = projeto;
    values.pacote = pacote;
    values.gestorTecnicoId = gestorTecnicoId;
    values.caracteristicaContratacao = caracteristicaContratacao || '';

    // faturamento direto

    values.valorPedido = valorPedido;
    values.vigencia = vigencia;
    values.valorTotalContrato = valorTotalContrato;
    values.dataTermino = prazoAtualPcs;
    values.condicaoPagamento = condicaoPagamento || '';
    values.tipoFaturamento = tipoFaturamento;
    values.justificativa = justificativaContratacao || '';
    values.objeto = demandaData && (demandaData.tipo === ETipoDemanda.FaturamentoDireto || demandaData.tipo === ETipoDemanda.AditivoFaturamentoDireto) ? objetoContratado || '' : values.objeto;

    values.relacionamentoEntidadePublica = relacionamentoEntidadePublica;
    values.haveraMaoDeObraEmPTR =
      demandaData &&
      (demandaData.tipo === ETipoDemanda.FaturamentoDireto ||
        demandaData.tipo === ETipoDemanda.AditivoFaturamentoDireto)
        ? haveraMaoDeObraEmPTRConfirmacao
        : values.haveraMaoDeObraEmPTR;
    values.itemCodigoContrato = selectedItemCodigoContrato || '';

    values.ordemCompraGuardaChuva = selectedOrdemCompra || '';
    values.ordemInvestimentoGuardaChuva = selectedOrdemInvestimento || '';

    values.caracteristicaContratacao = caracteristicaContratacao || '';

    // console.log('onUpdateDemanda', values);
    // console.log('numberIdStep', numberIdStep);
    // console.log('demandaData', demandaData);

    values.identificadorPQ = identificadorPQ  || '';

    if (!demandaData && numberIdStep === EStepQuestionarioDemanda.DadosdoRequisitante) {
      values.step = EStepQuestionarioDemanda.DadosdoRequisitante;
      createDemanda(values).then(data => {
        history.replace(`/demanda/questionario/${data.id}`);
        setId(data.id);
        onUpdate();
        return true;
      });
    }

    let forceUpdate = true;

    if (demandaData) {
      values.necessitaEspecificacao = demandaData.necessitaEspecificacao;

      switch (numberIdStep) {
        //case EStepQuestionarioDemandaFaturamentoDireto.Arquivos:
        //    forceUpdate = false;
        //      values.step = numberIdStep;
        //    updateDemanda(values).then(resp => {
        //      setExibirModalFinalizarEtapaFaturamentoDireto(true);
        //    });
        //  break;
        case EStepQuestionarioDemanda.DefinicaodoProcesso:
          forceUpdate = false;
          if (
            demandaData.tipo === ETipoDemanda.AcordodeFornecimento &&
            statusCodigo === EStatusDemanda.AguardandoPreenchimentoDemandante
          ) {
            values.step = numberIdStep;
            updateDemanda(values).then(resp => {
              setExibirModalFinalizarEtapaRequisicao(true);
            });
          } else {
            forceUpdate = true;
          }
          break;

        case EStepQuestionarioDemandaNovaContratacao.DadosQuantitativos:
        case EStepQuestionarioDemandaAditivo.DefinicaoAditivo:
          forceUpdate = false;
          if (demandaData.statusCodigo === EStatusDemanda.AguardandoPreenchimentoDemandante) {
            if (
              capex === true &&
              requisicaoAbertaPeloDepPlanejamentoControle === true &&
              exibirModalEnviarValidacaoCapex === false
            ) {
              setExibirModalEnviarValidacaoCapex(true);
            } else if (contaResultado === true && exibirModalEnviarValidacaoContaResultado === false) {
              setExibirModalEnviarValidacaoContaResultado(true);
            } else if (opex === true && exibirModalEnviarValidacaoOpex === false) {
              setExibirModalEnviarValidacaoOpex(true);
            } else {
              setExibirModalEnviarValidacaoCapex(false);
              setExibirModalEnviarValidacaoContaResultado(false);
              setExibirModalEnviarValidacaoOpex(false);

              values.step = numberIdStep;
              forceUpdate = true;
            }
          }
          break;

        case EStepQuestionarioDemanda.Arquivos:
          forceUpdate = false;
          if (demandaData.statusCodigo === EStatusDemanda.AguardandoPreenchimentoDemandante) {
            values.step = numberIdStep;
            updateDemanda(values).then(resp => {
              if (resp.valid) {
                onUpdate();

                if (isAdmContrato) {
                  setExibirModalFinalizarEtapaDados(true);
                }
              }
            });
          }
          break;

        case EStepQuestionarioDemanda.DadosRequisicao:
          forceUpdate = false;
          if (demandaData.statusCodigo === EStatusDemanda.AguardandoPreenchimentoDemandante) {
            updateDemanda(values).then(resp => {
              if (resp.valid) {
                onUpdate();

                if (!isAdmContrato) {
                  setExibirModalFinalizarEtapaDados(true);
                }
              }
            });
          }
          break;

        case EStepQuestionarioDemandaValidacao.PreContratacao:
          forceUpdate = false;
          if (statusCodigo === EStatusDemanda.AguardandoPreenchimentoDemandante) {
            values.expectativaDePrazoConfirmacao = expectativaDePrazoConfirmacao;
            values.haveraMaoDeObraEmPTRConfirmacao = haveraMaoDeObraEmPTRConfirmacao;
            values.haveraSlaConfirmacao = haveraSlaConfirmacao;
            values.haveraDespesasReembolsaveisConfirmacao = haveraDespesasReembolsaveisConfirmacao;
            values.novoPrazoConfirmacao = novoPrazoConfirmacao;
            values.isVisitaTecnicaConfirmacao = isVisitaTecnicaConfirmacao;
            values.id = id || '';
            FinalizarEtapaDadosQuestionario(values).then(data => {
              if (data) {
                onUpdate();
              }
            });
          }

          break;

        case EStepQuestionarioDemandaMinuta.MinutadeContrato:
          if (demandaData.tipo === ETipoDemanda.AditivoFaturamentoDireto) {
            values.step = numberIdStep;
            forceUpdate = true;
            break;
          }
          forceUpdate = false;
          let qtdPerguntas = (demandaData.perguntasQuestionarioMinuta || []).length;
          let ultimoStepMinuta = qtdPerguntas + (EStepQuestionarioDemandaMinuta.MinutadeContrato - 1);

          if ([EStatusDemanda.AguardandoConfirmacaoQuestionarioMinuta].includes(statusCodigo || 0)) {
            if (verificarRespostasFaltantes() && stepOrdinal !== ultimoStepMinuta) {
              ui.notification.error('Preencha todas as respostas antes de continuar');
            } else {
              onEnviarDadosDasPerguntasMinutaQuestionario();
            }
          }
          break;

        case EStepQuestionarioDemandaRequisicao.ValorDirecionamentoeEmergencial:
          if (statusCodigo === EStatusDemanda.AguardandoRCDemandante) {
            forceUpdate = false;

            if (
              values.expectativaValorFinal >= (minAprovacaoGpc || 0) &&
              demandaData.expectativaValorFinal < (minAprovacaoGpc || 0) &&
              exibirModalEnviarPreSuprimentos === false
            ) {
              setExibirModalEnviarPreSuprimentos(true);
            } else {
              setExibirModalEnviarPreSuprimentos(false);

              updateDemanda(values).then(resp => {
                setExibirModalFinalizarEtapaRequisicao(true);
              });
            }
          }

          break;
      }
    }

    if (forceUpdate) {
      return updateDemanda(values).then(resp => {
        if (resp.valid) {
          onUpdate();
        }

        return resp.valid;
      });
    }

    return false;
  };

  const renderSteps = (form: FormikProps<any>) => {
    let showEliminar =
      ![
        EStatusDemanda.Cancelada,
        EStatusDemanda.AguardandoAnalisePreSuprimentos,
        EStatusDemanda.AguardandoAnaliseControleFinanceiro,
        EStatusDemanda.AguardandoAnaliseControleFinanceiroModificacao,
        EStatusDemanda.AguardandoAnaliseControleFinanceiroReavaliacao,
        EStatusDemanda.AguardandoAnaliseControladoria,
        EStatusDemanda.AguardandoAnaliseControladoriaModificacao,
        EStatusDemanda.AguardandoAnaliseControladoriaReavaliacao,
        EStatusDemanda.OnHoldDemandante,
        EStatusDemanda.AguardandoGestorTecnico,
        EStatusDemanda.AguardandoQuestionarioMinuta,
        EStatusDemanda.AguardandoConfirmacaoQuestionarioMinuta,
        EStatusDemanda.AguardandoGeracaoMinuta,
        EStatusDemanda.AguardandoRCReabertura,
        EStatusDemanda.AguardandoRCDemandanteReavaliacao,
        EStatusDemanda.AguardandoContratacaoSuprimentosReavaliacao,
      ].includes(statusCodigo || 0) && ![EStepQuestionarioDemanda.DadosdoRequisitante].includes(numberIdStep);

    let showCancelarOc = [
      EStatusDemanda.AguardandoRCReabertura,
      EStatusDemanda.AguardandoRCDemandanteReavaliacao,
      EStatusDemanda.AguardandoContratacaoSuprimentosReavaliacao,
    ].includes(statusCodigo || 0);

    if ([EStatusDemanda.AguardandoRCDemandante].includes(statusCodigo || 0)) {
      if (capex || contaResultado) {
        if (demandaData.requisicaoAbertaPeloDepPlanejamentoControle) {
          if (hasPermissionPerfil([EGuidPerfilAcesso.RequisitanteCapex])) {
            showEliminar = true;
          } else {
            showEliminar = false;
          }
        } else {
          if (demandaData.requisitanteId === loggedId) {
            showEliminar = true;
          } else {
            showEliminar = false;
          }
        }
      }
    }

    let actions: React.ReactNode[] = [
      showEliminar && <ModalEliminarDemanda update={update} setUpdate={setUpdate} />,

      showCancelarOc && (
        <ModalInclusaoMultAnexo
          // buttonIcon="commons-plus"
          buttonLabel={demandaData && isObjEmpty(demandaData.tipoReavaliacao) ? 'Cancelar OC' : 'Cancelar Demanda'}
          buttonType="danger"
          onSubmit={async values => {
            if ('justificativa' in values && values.justificativa) {
              return true;
            }
            return false;
          }}
          showJustificativa
          isJustificativaInput
          textButtonSave="Salvar"
          showUploadArquivos={false}
          modalConfirmType="confirm"
          modalConfirmTitle={
            demandaData && isObjEmpty(demandaData.tipoReavaliacao) ? 'Cancelar OC' : 'Cancelar Demanda'
          }
          modalConfirmContent={
            'Você tem certeza que deseja cancelar a OC e, consequentemente, eliminar a demanda? Ao cancelar a OC o processo de contratação será descontinuado.'
          }
          modalConfirmOnOk={values => {
            if (demandaData) {
              cancelarOCDemanda(demandaData.id, values[0].justificativa);
            }
          }}
          modalConfirmOnCancel={() => {}}
          modalConfirmOkText="Sim"
          modalConfirmCancelText="Não"
        />
      ),

      [
        EStepQuestionarioDemandaRequisicao.ObjetoeJustificativa,
        EStepQuestionarioDemandaRequisicao.ItemdeServicoeAlocacaodeCusto,
        EStepQuestionarioDemandaRequisicao.ValorDirecionamentoeEmergencial,
        EStepQuestionarioDemandaRequisicao.AguardandoAprovacaoRC,
        EStepQuestionarioDemandaRequisicaoModificacao.ObjetoeJustificativa,
        EStepQuestionarioDemandaRequisicaoModificacao.ItemdeServicoeAlocacaodeCusto,
        EStepQuestionarioDemandaRequisicaoModificacao.ValorDirecionamentoeEmergencial,
        EStepQuestionarioDemandaRequisicaoModificacao.AguardandoAprovacaoRC,
      ].includes(numberIdStep) &&
        [EStatusDemanda.AguardandoGeracaoOCnoTotvs, EStatusDemanda.AguardandoGeracaoOCePreSuprimentosDDI].includes(
          statusCodigo || 0,
        ) &&
        demandaData &&
        demandaData.tipo !== ETipoDemanda.AcordodeFornecimento &&
        demandaData.demandaAprovadaNoTotvs == false && <ModalModificarRC update={update} setUpdate={setUpdate} />,

      [EStatusDemanda.AguardandoPreenchimentoDemandante].includes(statusCodigo || 0) &&
        ![EStepQuestionarioDemanda.DadosdoRequisitante].includes(numberIdStep) &&
        numberIdStep > 0 &&
        numberIdStep <= EStepQuestionarioDemandaRequisicao.AguardandoAprovacaoRC && (
          <Tooltip title="Colocar a demanda On Hold">
            <ui.Button id="mrn-button-pausar-demanda" type="primary" onClick={handlePausar}>
              Pausar
            </ui.Button>
          </Tooltip>
        ),

      [EStatusDemanda.OnHoldDemandante].includes(statusCodigo || 0) && (
        <Tooltip title="Retomar a demanda">
          <ui.Button id="mrn-button-retomar-demanda" type="primary" onClick={handleRetomar}>
            Retomar
          </ui.Button>
        </Tooltip>
      ),
    ];

    let showNext =
      [EStatusDemanda.AguardandoQuestionarioMinuta].includes(statusCodigo || 0) == false &&
      [
        EStepQuestionarioDemandaRequisicao.AguardandoAprovacaoRC,
        EStepQuestionarioDemandaRequisicaoModificacao.AguardandoAprovacaoRC,
        EStepQuestionarioDemandaReavaliacaoRC.AguardandoAprovacaoRC,
        EStepQuestionarioDemandaRequisicao.AguardandoSuprimentos,
      ].includes(numberIdStep) == false;

    if ([EStatusDemanda.AguardandoRCDemandante].includes(statusCodigo || 0)) {
      if (capex || contaResultado) {
        if (demandaData.requisicaoAbertaPeloDepPlanejamentoControle) {
          if (hasPermissionPerfil([EGuidPerfilAcesso.RequisitanteCapex])) {
            showNext = true;
          } else {
            showNext = false;
          }
        } else {
          if (demandaData.requisitanteId === loggedId) {
            showNext = true;
          } else {
            showNext = false;
          }
        }
      }
    }

    if (
      statusCodigo === EStatusDemanda.AguardandoContratacaoSuprimentosReavaliacao &&
      numberIdStep === EStepQuestionarioDemandaReavaliacaoRC.AguardandoAprovacaoRC
    ) {
      showNext = true;
    }

    // IN0726-5080: se o PRÓXIMO não tem para onde levar neste step + status, não exibir.
    if (demandaData && !stepAvancaNoStatus(numberIdStep, statusCodigo || 0)) {
      showNext = false;
    }

    let showPrev =
      ![EStatusDemanda.AguardandoQuestionarioMinuta].includes(statusCodigo || 0) &&
      ![
        !isAdmContrato || isGPC ? EStepQuestionarioDemanda.Arquivos : EStepQuestionarioDemanda.DadosRequisicao,
        EStepQuestionarioDemandaRequisicao.ObjetoeJustificativa,
        EStepQuestionarioDemandaRequisicaoModificacao.ObjetoeJustificativa,
        EStepQuestionarioDemandaReavaliacaoRC.ObjetoeJustificativa,
        demandaData && demandaData.tipo !== ETipoDemanda.AditivoFaturamentoDireto ? EStepQuestionarioDemandaMinuta.MinutadeContrato : -1,
        EStepQuestionarioDemandaReavaliacaoRC.DefinicaoReavaliacao,
      ].includes(numberIdStep);

    let showAllActions =
      demandaData &&
      (demandaData.demandanteId === loggedId ||
        demandaData.requisitanteId === loggedId ||
        hasPermission(['PRE_SUPRIMENTOS_DEMANDA_VISUALIZAR_ABA_QUESTIONARIO'])) &&
      [
        EStatusDemanda.Cancelada,
        EStatusDemanda.Concluido,
        EStatusDemanda.AguardandoAnaliseControleFinanceiro,
        EStatusDemanda.AguardandoAnaliseControleFinanceiroModificacao,
        EStatusDemanda.AguardandoAnaliseControleFinanceiroReavaliacao,
        EStatusDemanda.AguardandoGeracaoMinuta,
        EStatusDemanda.AguardandoGestorTecnico,
        EStatusDemanda.AguardandoAnaliseControladoria,
        EStatusDemanda.AguardandoAnaliseControladoriaModificacao,
        EStatusDemanda.AguardandoAnaliseControladoriaReavaliacao,
      ].includes(statusCodigo || 0) == false;

    if (
      [EStatusDemanda.AguardandoGerenteDepartamento].includes(statusCodigo || 0) ||
      [EStatusDemanda.AguardandoGerenteGeral].includes(statusCodigo || 0)
    ) {
      showPrev = false;
      showNext = false;
    }

    return (
      <V2StepPanel
        groupSteps={stepsGroup}
        header={demandaForm}
        numberCurrentStep={demandaData ? demandaData.step : EStepQuestionarioDemanda.DadosdoRequisitante}
        contentLegend={legend}
        onChangeStep={step => {
          setNumberIdStep(step.stepNumber);
        }}
        onChangeStepOrdinal={value => {
          setStepOrdinal(value);
        }}
        showPrev={showPrev}
        onPrev={async (referenceStep, ordinal, allSteps) => {
          if (!referenceStep.stepFrontendControl) {
            //Usado para voltar o step da demanda quando nao é controlado pelo frontend
            let demandaTemp = JSON.parse(JSON.stringify(demandaData)) as Demanda;
            // if (demandaData && referenceStep.stepNumber < demandaData.step) {
            demandaTemp.step = referenceStep.stepNumber;
            demandaTemp.forceStep = true;
            if(demandaData && [EStatusDemanda.AguardandoConfirmacaoQuestionarioMinuta].includes(statusCodigo || 0) && demandaData.step == EStepQuestionarioDemandaMinuta.MinutadeContrato) {
              ui.notification.error('Não é possível voltar depois de gerar a minuta');
              return false
            }

            // IN0726-5080: bloquear o retorno a um step de fase já concluída. Gravá-lo
            // deixaria a demanda num beco sem saída — sem PRÓXIMO e sem o botão Modificar.
            if (demandaData && !stepAvancaNoStatus(referenceStep.stepNumber, statusCodigo || 0)) {
              ui.notification.warn(
                'Esta etapa já foi concluída e não pode ser reaberta no status atual da demanda.',
              );
              return false;
            }

            updateDemanda(demandaTemp).then(resp => {
              onUpdate();
              return resp.valid;
            });
            // }
          }

          return true;
        }}
        showNext={showNext}
        onNext={async (step, ordinal) => {
          return true
          if (demandaData) {
            if (
              demandaData.tipo !== ETipoDemanda.AditivoFaturamentoDireto &&
              [EStatusDemanda.AguardandoConfirmacaoQuestionarioMinuta].includes(statusCodigo || 0) &&
              [EStepQuestionarioDemandaMinuta.MinutadeContrato].includes(step.stepNumber || 0)
            ) {
              if (verificarRespostasFaltantes() && isObjNotEmpty(step.hash)) {
                ui.notification.error('Preencha todas as respostas antes de continuar');
                return false;
              }
            }
          }
          return true;
        }}
        actions={actions}
        showAllActions={showAllActions}
      />
    );
  };

  return (
    <ui.MasterDetailForm key="formTemplate" initialValues={demandaData} onSubmit={onUpdateDemanda}>
      <ui.FormContext.Consumer>
        {({ formProps }) => stepsGroup.length > 0 && formProps && renderSteps(formProps)}
      </ui.FormContext.Consumer>
    </ui.MasterDetailForm>
  );
}

export default EditQuestionarioContratacao;
